// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__FxdWE","header":"MessagesList_header__3hqmB","chat":"MessagesList_chat__1zqUo"};